import HelpAndShare from "components/LayoutFront/HelpAndShare";
import Wrapper from "components/LayoutFront/Wrapper";
import Block from "components/templatesComponents/Block";
import PageTitle from "components/templatesComponents/PageTitle";
import PropTypes from "prop-types";
import React from "react";

const HelpDetails = (props) => {
  const { page = {} } = props;
  const { title, contents, template } = page;
  const { questions, cta } = contents;

  return (
    <>
      <Wrapper>
        <Block>
          <PageTitle>{title}</PageTitle>
        </Block>

        {/* questions / answers */}
        <Block>{questions}</Block>

        {/* button cta */}
        <Block sx={{ textAlign: "center", mb: 4, "& p": { mt: 1, mb: 1.75 } }}>
          <h3>{cta.title}</h3>
          {cta.button}
        </Block>
      </Wrapper>
      <HelpAndShare alwaysDisplayShare template={template} />
    </>
  );
};

HelpDetails.propTypes = {
  page: PropTypes.shape(),
};

export default HelpDetails;
